export { default } from './ButtonRemoveProductFromShoppingCart';
